export const STORE_OFFLINE_NOTIFICATION_DATA = {
    "id": 1,
    "placement": "relative",
    "displayAs": "display",
    "position": 0,
    "title": "Sorry, store is unserviceable at your location",
    "frequency": "DAILY"
};